export default __webpack_public_path__ + "static/media/Newsletter 004.6ccda3f2.png";